<template>
  <v-tooltip v-if="status" bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" small :color="status.color">{{ status.icon }}</v-icon>
    </template>
    <span>{{ status.name }}<span v-if="payslip.email_to"> ({{ payslip.email_to }})</span></span>
  </v-tooltip>
</template>

<script>
import { EMAIL_STATUSES } from "@/constants/payslips";

// Estado del aviso por email de un recibo publicado
export default {
  props: {
    payslip: Object,
  },
  computed: {
    status() {
      return this.payslip.email_status ? EMAIL_STATUSES[this.payslip.email_status] : null;
    },
  },
};
</script>
